const programList = document.querySelector('.program-list');

if (programList) {
  // *******************************************************************************
  // Slider
  // *******************************************************************************

  const programListSlider = programList.querySelectorAll('[data-slider="program-list-slider"]');

  const programListOptions = {
    slidesPerView: 'auto',
    spaceBetween: 20,
    speed: 800,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
  };

  programListSlider.forEach((el) => {
    const parentElem = el.closest('.program-list');

    const arrowLeft = parentElem.querySelector('.swiper-button-prev');
    const arrowRight = parentElem.querySelector('.swiper-button-next');
    const pagination = parentElem.querySelector('.swiper-pagination');

    programListOptions.navigation.prevEl = arrowLeft;
    programListOptions.navigation.nextEl = arrowRight;
    programListOptions.pagination.el = pagination;

    new Swiper(el, programListOptions);
  });

  // *******************************************************************************
  // Axios
  // *******************************************************************************

  const urlParams = ['locations', 'types', 'audiences', 'grades', 'searchTerm', 'pageNumber'];

  const getExtraFormDataInput = (parent, searchInput) => ({
    searchTerm: searchInput || getSearchedData(parent),
    postType: parent.querySelector('[data-post-type]').value,
    programType: parent.querySelector('[data-program-type]').value,
    postNotIn: parent.querySelector('[data-post-not-in]').value,
    locations: getCheckedData(parent, 'locations'),
    types: getActiveCategoryButtonFilter(parent),
    audiences: getCheckedData(parent, 'audiences'),
    grades: getCheckedData(parent, 'grades'),
  });

  // Filter dropdown click
  attachEvent('.program-list .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.program-list__inner');
    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Filter button click
  attachEvent('.program-list .mod-filter .filter-buttons button', 'click', (ev) => {
    const parent = ev.target.closest('.program-list__inner');
    ev.target.classList.toggle('is-active');
    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.program-list .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.program-list__inner');
    axiosGetPaginateAndFilteredPosts(parent, ev.target.dataset.page, urlParams, getExtraFormDataInput(parent));
  });

  // Search
  programList.querySelector('.filter-search__form')?.addEventListener('submit', (ev) => {
    ev.preventDefault();

    const form = ev.target;
    const baseUrl = form.querySelector('button[type="submit"]')?.dataset.href;
    const searchQuery = form.querySelector('input[name="filter_search"]')?.value.trim();

    if (baseUrl && searchQuery) {
      const redirectUrl = `${baseUrl}?searchTerm=${encodeURIComponent(searchQuery)}&searchCpt=program`;
      window.location.href = redirectUrl;
    }
  });
}
